import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import SteamStudiosLanding from './App.jsx'
import WorkWithUs from './WorkWithUs.jsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SteamStudiosLanding />} />
        <Route path="/work-with-us" element={<WorkWithUs />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
)